import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { SfWebMessagesService } from './core/services/sf-web-messages.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { GetLocaleStore } from '../../dictionary/store/get-locale.store';
import { gettingBrandingSelector } from '../../core/store/core.selectors';

@Component({
  selector: 'app-root',
  template: `
    @if (loadingData()) {
      <app-sd-progress-bar-a11y progressBarType="main" />
    }
    @if (!loadingData()) {
      <div class="sf-app-root">
        <router-outlet />
      </div>
    }
  `,
  styles: [
    `
      .sf-app-root {
        background-color: var(--appBackground);
        height: 100%;
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SfAppComponent {
  private readonly service = inject(SfWebMessagesService);
  private readonly store = inject(Store<AppState>);
  private readonly getLocaleStore = inject(GetLocaleStore);
  private readonly gettingBranding = this.store.selectSignal(
    gettingBrandingSelector
  );
  loadingData = computed(
    () => this.getLocaleStore.loading() || this.gettingBranding()
  );
}
